<template>
  <div>
    <v-toolbar absolute>
      <v-toolbar-side-icon @click='setDrawer' />
      <p class="app-heading">{{getHead()}}</p>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <search-text-filed v-if='showToolbarItems()' />
        <search v-if='showToolbarItems()' />
        <dateRangePicker v-if='showToolbarItems()' />
        <role-group />
        <export-to-excel v-if='canBeExported()' />
        <refresh v-if='showToolbarItems()' />
        <locale-picker />
        <change-password-icon />
        <logout />
      </v-toolbar-items>
    </v-toolbar>
    <calendar />
  </div>
</template>

<script>
import ChangePasswordIcon from './ChangePasswordIcon'
import SearchTextFiled from './SearchTextFiled'
import Logout from './Logout'
import Search from './Search'
import Refresh from './Refresh'
import DateRangePicker from './DateRangePicker'
import ExportToExcel from './ExportToExcel'
import Calendar from './Calendar'
import RoleGroup from './RoleGroup'
import LocalePicker from './LocalePicker'

export default {
  name: 'Toolbar',

  components: {
    ChangePasswordIcon,
    SearchTextFiled,
    DateRangePicker,
    ExportToExcel,
    Logout,
    Refresh,
    Search,
    Calendar,
    RoleGroup,
    LocalePicker
  },

  methods: {
    setInputToSearchToQuery (searchValue) {
      this.searchValue = searchValue
    },

    setSearchDatesToQuery (dates) {
      this.dates = dates
    },
    objectIsEmpty (object) {
      return Object.keys(object).length === 0 && object.constructor === Object
    },
    setDrawer () {
      this.$store.commit('setDrawer', !this.$store.state.drawer)
    },
    canBeExported () {
      let collectionType = this.$route.name.toLowerCase()
      if (collectionType === 'transactions') {
        let collection = this.$store.state.transactions
        return !this.objectIsEmpty(collection)
      } else if (collectionType === 'subscriptions') {
        let collection = this.$store.state.subscriptions
        return !this.objectIsEmpty(collection)
      } else {
        return false
      }
    },

    getHead () {
      let collectionType = this.$route.name.toLowerCase()
      if (collectionType === 'addsubscriber') {
        return this.$t('addSubHead')
      } else if (collectionType === 'telemarketing') {
        return this.$t('telemarketingHead')
      } else if (collectionType === 'subscriptions') {
        return this.$t('ordersHead')
      } else if (collectionType === 'transactions') {
        return this.$t('trxHead')
      } else if (collectionType === 'webhooklogs') {
        return this.$t('webhooksHead')
      } else if (collectionType === 'changepassword') {
        return this.$t('changePasswordHead')
      }
    },

    showToolbarItems () {
      let collectionType = this.$route.name.toLowerCase()
      if (
        collectionType === 'telemarketing' ||
        collectionType === 'addsubscriber' ||
        collectionType === 'changepassword' ||
        collectionType === 'manageusers' ||
        collectionType === 'edituser'
      ) {
        return false
      }
      return true
    }
  }
}
</script>
<style scoped>
  .app-heading{
      margin: 0;
      font-weight: 900;
      color: #1A76D2;
      font-size: larger;
  }
</style>



// WEBPACK FOOTER //
// src/components/Toolbar.vue